import { render, staticRenderFns } from "./AdmisionHabilitadosEscrita.vue?vue&type=template&id=0577e2ff"
import script from "./AdmisionHabilitadosEscrita.vue?vue&type=script&lang=js"
export * from "./AdmisionHabilitadosEscrita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports